// Verified blue check badge (Twitter-style) for fully verified pros
import { CheckCheck } from "lucide-react";

export default function VerifiedBadge({ size = 16 }) {
  return (
    <span title="Professionnel vérifié Doctobook" className="inline-flex items-center justify-center rounded-full bg-[#618DB8] text-white align-middle"
      style={{ width: size + 2, height: size + 2, marginLeft: 4, flexShrink: 0 }}>
      <CheckCheck style={{ width: size - 4, height: size - 4 }} strokeWidth={3} />
    </span>
  );
}
